import { Icon, type IconProps } from "../icon";

const PATHS = [
  "M5 10.0576C5 7.2686 7.269 4.9996 10.058 4.9996C12.846 4.9996 15.115 7.2686 15.115 10.0576C15.115 12.8466 12.846 15.1146 10.058 15.1146C7.269 15.1146 5 12.8466 5 10.0576ZM20.207 18.7926L15.697 14.2826C16.583 13.1026 17.115 11.6426 17.115 10.0576C17.115 6.1656 13.949 2.9996 10.058 2.9996C6.166 2.9996 3 6.1656 3 10.0576C3 13.9486 6.166 17.1146 10.058 17.1146C11.643 17.1146 13.103 16.5826 14.283 15.6966L18.793 20.2066C18.988 20.4026 19.244 20.4996 19.5 20.4996C19.756 20.4996 20.012 20.4026 20.207 20.2066C20.598 19.8166 20.598 19.1836 20.207 18.7926Z",
];

export function SearchIcon(props: IconProps) {
  return <Icon paths={PATHS} {...props} />;
}
